import React from "react";
import AccountName from "components/v3/subscription-details/account-name/AccountName";
import styles from "../styles.module.scss";

const TerminalSubscriptionDetails = () => {
    return (
        <div className={ styles.details }>
            <AccountName name="Bloomberg.com Digital Access" />
            <div className={ styles.notice }>
                <p>
                    As a valued Terminal Client, you have free access to Bloomberg.com.
                    If you need assistance please contact the Terminal Help desk.
                </p>
                <p>
                    Your service also includes a subscription to home delivery of all Bloomberg magazines.
                    Please visit <a href="bbg://screens/HDLV">HDLV &lt;GO&gt;</a> to sign-up.
                </p>
            </div>
        </div>
    );
};

export default TerminalSubscriptionDetails;
